'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_Duration$() {
  this.J3 = null;
  this.J4 = false;
}
export { $c_Ljava_time_Duration$ as $c_Ljava_time_Duration$ };
$p = $c_Ljava_time_Duration$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Duration$;
/** @constructor */
function $h_Ljava_time_Duration$() {
}
export { $h_Ljava_time_Duration$ as $h_Ljava_time_Duration$ };
$h_Ljava_time_Duration$.prototype = $p;
$p.NM = (function() {
  if ((!this.J4)) {
    this.J3 = new $c_Ljava_time_Duration(0, 0, 0);
    this.J4 = true;
  }
  return this.J3;
});
$p.Ws = (function(seconds_$_lo, seconds_$_hi, nanoAdjustment_$_lo, nanoAdjustment_$_hi) {
  var sign = (nanoAdjustment_$_hi >> 31);
  var xlo = (nanoAdjustment_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((nanoAdjustment_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000017E-9 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((nanoAdjustment_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var quot_$_lo = lo$2;
    var quot_$_hi = hi$2;
  } else {
    var quot_$_lo = absR_$_lo;
    var quot_$_hi = absR_$_hi;
  }
  if ((nanoAdjustment_$_hi >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & quot_$_lo);
    var b1 = ((quot_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(51712, b0);
    var a1b0 = Math.imul(15258, b0);
    var a0b1 = Math.imul(51712, b1);
    var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var $x_1 = (((lo$4 ^ nanoAdjustment_$_lo) | (((((((Math.imul(1000000000, quot_$_hi) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0) ^ nanoAdjustment_$_hi)) === 0);
  }
  if ($x_1) {
    var b_$_lo = quot_$_lo;
    var b_$_hi = quot_$_hi;
  } else {
    var lo$5 = ((quot_$_lo - 1) | 0);
    var hi$4 = ((((quot_$_hi - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
    var b_$_lo = lo$5;
    var b_$_hi = hi$4;
  }
  var this$19 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
  var lo$6 = ((seconds_$_lo + b_$_lo) | 0);
  var hi$5 = ((((seconds_$_hi + b_$_hi) | 0) + (((lo$6 >>> 0) < (seconds_$_lo >>> 0)) | 0)) | 0);
  if ((((hi$5 ^ seconds_$_hi) & (hi$5 ^ b_$_hi)) < 0)) {
    this$19.au();
  }
  var sign$1 = (nanoAdjustment_$_hi >> 31);
  var xlo$1 = (nanoAdjustment_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((nanoAdjustment_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
  var x$2 = (1.0000000000000017E-9 * aHat$1);
  var lo$10 = (x$2 | 0.0);
  ((2.3283064365386963E-10 * x$2) | 0.0);
  var rHat$1 = ((rlo$1 - Math.imul(1000000000, lo$10)) | 0);
  if ((rHat$1 < 0)) {
    var lo$11 = ((1000000000 + rHat$1) | 0);
    var absR$1_$_lo = lo$11;
    var absR$1_$_hi = 0;
  } else {
    var absR$1_$_lo = rHat$1;
    var absR$1_$_hi = 0;
  }
  if ((nanoAdjustment_$_hi < 0)) {
    var lo$12 = ((-absR$1_$_lo) | 0);
    var hi$10 = ((((-absR$1_$_hi) | 0) - ((lo$12 !== 0) | 0)) | 0);
    var rem_$_lo = lo$12;
    var rem_$_hi = hi$10;
  } else {
    var rem_$_lo = absR$1_$_lo;
    var rem_$_hi = absR$1_$_hi;
  }
  if (((nanoAdjustment_$_hi >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
    var x$4_$_lo = rem_$_lo;
    var x$4_$_hi = rem_$_hi;
  } else {
    var lo$14 = ((1000000000 + rem_$_lo) | 0);
    var hi$11 = ((rem_$_hi + (((lo$14 >>> 0) < 1000000000) | 0)) | 0);
    var x$4_$_lo = lo$14;
    var x$4_$_hi = hi$11;
  }
  return this.eV(lo$6, hi$5, x$4_$_lo);
});
$p.Ce = (function(nanos_$_lo, nanos_$_hi) {
  var sign = (nanos_$_hi >> 31);
  var xlo = (nanos_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((nanos_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000017E-9 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((nanos_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var secs_$_lo = lo$2;
    var secs_$_hi = hi$2;
  } else {
    var secs_$_lo = absR_$_lo;
    var secs_$_hi = absR_$_hi;
  }
  var sign$1 = (nanos_$_hi >> 31);
  var xlo$1 = (nanos_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((nanos_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
  var x$2 = (1.0000000000000017E-9 * aHat$1);
  var lo$3 = (x$2 | 0.0);
  ((2.3283064365386963E-10 * x$2) | 0.0);
  var rHat$1 = ((rlo$1 - Math.imul(1000000000, lo$3)) | 0);
  if ((rHat$1 < 0)) {
    var lo$4 = ((1000000000 + rHat$1) | 0);
    var absR$1_$_lo = lo$4;
    var absR$1_$_hi = 0;
  } else {
    var absR$1_$_lo = rHat$1;
    var absR$1_$_hi = 0;
  }
  if ((nanos_$_hi < 0)) {
    var lo$5 = ((-absR$1_$_lo) | 0);
    var hi$4 = ((((-absR$1_$_hi) | 0) - ((lo$5 !== 0) | 0)) | 0);
    var $x_1_$_lo = lo$5;
    var $x_1_$_hi = hi$4;
  } else {
    var $x_1_$_lo = absR$1_$_lo;
    var $x_1_$_hi = absR$1_$_hi;
  }
  var nos = $x_1_$_lo;
  if ((nos < 0)) {
    nos = ((1000000000 + nos) | 0);
    var x$5_$_lo = secs_$_lo;
    var x$5_$_hi = secs_$_hi;
    var lo$6 = ((x$5_$_lo - 1) | 0);
    var hi$5 = ((((x$5_$_hi - 1) | 0) + ((lo$6 !== (-1)) | 0)) | 0);
    secs_$_lo = lo$6;
    secs_$_hi = hi$5;
  }
  return this.eV(secs_$_lo, secs_$_hi, nos);
});
$p.eV = (function(seconds_$_lo, seconds_$_hi, nanoAdjustment) {
  var hi = (nanoAdjustment >> 31);
  if ((((seconds_$_lo | nanoAdjustment) | (seconds_$_hi | hi)) === 0)) {
    return this.NM();
  } else {
    return new $c_Ljava_time_Duration(seconds_$_lo, seconds_$_hi, nanoAdjustment);
  }
});
var $d_Ljava_time_Duration$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Duration$, "java.time.Duration$", ({
  kP: 1
}));
export { $d_Ljava_time_Duration$ as $d_Ljava_time_Duration$ };
var $n_Ljava_time_Duration$;
function $m_Ljava_time_Duration$() {
  if ((!$n_Ljava_time_Duration$)) {
    $n_Ljava_time_Duration$ = new $c_Ljava_time_Duration$();
  }
  return $n_Ljava_time_Duration$;
}
export { $m_Ljava_time_Duration$ as $m_Ljava_time_Duration$ };
/** @constructor */
function $c_Ljava_time_Duration(seconds_$_lo, seconds_$_hi, nanos) {
  this.ha = 0;
  this.hb = 0;
  this.g8 = 0;
  this.ha = seconds_$_lo;
  this.hb = seconds_$_hi;
  this.g8 = nanos;
}
export { $c_Ljava_time_Duration as $c_Ljava_time_Duration };
$p = $c_Ljava_time_Duration.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Duration;
/** @constructor */
function $h_Ljava_time_Duration() {
}
export { $h_Ljava_time_Duration as $h_Ljava_time_Duration };
$h_Ljava_time_Duration.prototype = $p;
$p.Of = (function(otherDuration) {
  var x_$_lo = this.ha;
  var x_$_hi = this.hb;
  var y_$_lo = otherDuration.ha;
  var y_$_hi = otherDuration.hb;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  return ((cmp !== 0) ? cmp : ((this.g8 - otherDuration.g8) | 0));
});
$p.f = (function(other) {
  if ((other instanceof $c_Ljava_time_Duration)) {
    if ((this === other)) {
      return true;
    } else {
      var x_$_lo = this.ha;
      var x_$_hi = this.hb;
      var $x_1 = other;
      var x$1_$_lo = $x_1.ha;
      var x$1_$_hi = $x_1.hb;
      if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
        return (this.g8 === other.g8);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var x$1_$_lo = this.ha;
  var x$1_$_hi = this.hb;
  var x_$_lo = this.ha;
  var x_$_hi = this.hb;
  return (((x$1_$_lo ^ x_$_hi) + Math.imul(51, this.g8)) | 0);
});
$p.b = (function() {
  if ((this === $m_Ljava_time_Duration$().NM())) {
    return "PT0S";
  }
  var num_$_lo = this.ha;
  var num_$_hi = this.hb;
  var sign = (num_$_hi >> 31);
  var xlo = (num_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 3600) | 0);
  var k = ((rhi - Math.imul(3600, quotHi)) | 0);
  var quotLo = ((2.777777777777779E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((num_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    var hours_$_lo = lo;
    var hours_$_hi = hi;
  } else {
    var hours_$_lo = quotLo;
    var hours_$_hi = quotHi;
  }
  var num$1_$_lo = this.ha;
  var num$1_$_hi = this.hb;
  var sign$1 = (num$1_$_hi >> 31);
  var xlo$1 = (num$1_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((num$1_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var k$2 = (((rhi$1 >>> 0) % 3600) | 0);
  var quotLo$2 = ((2.777777777777779E-4 * ((4.294967296E9 * k$2) + (rlo$1 >>> 0.0))) | 0.0);
  var remLo = ((rlo$1 - Math.imul(3600, quotLo$2)) | 0);
  if ((num$1_$_hi < 0)) {
    var lo$1 = ((-remLo) | 0);
    var hi$1 = ((-((lo$1 !== 0) | 0)) | 0);
    var num$2_$_lo = lo$1;
    var num$2_$_hi = hi$1;
  } else {
    var num$2_$_lo = remLo;
    var num$2_$_hi = 0;
  }
  var sign$2 = (num$2_$_hi >> 31);
  var xlo$2 = (num$2_$_lo ^ sign$2);
  var rlo$2 = ((xlo$2 - sign$2) | 0);
  var rhi$2 = (((num$2_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
  var quotHi$1 = (((rhi$2 >>> 0) / 60) | 0);
  var k$1 = ((rhi$2 - Math.imul(60, quotHi$1)) | 0);
  var quotLo$1 = ((0.016666666666666673 * ((4.294967296E9 * k$1) + (rlo$2 >>> 0.0))) | 0.0);
  if ((num$2_$_hi < 0)) {
    var lo$2 = ((-quotLo$1) | 0);
    var hi$2 = ((((-quotHi$1) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var x$3_$_lo = lo$2;
    var x$3_$_hi = hi$2;
  } else {
    var x$3_$_lo = quotLo$1;
    var x$3_$_hi = quotHi$1;
  }
  var num$3_$_lo = this.ha;
  var num$3_$_hi = this.hb;
  var sign$3 = (num$3_$_hi >> 31);
  var xlo$3 = (num$3_$_lo ^ sign$3);
  var rlo$3 = ((xlo$3 - sign$3) | 0);
  var rhi$3 = (((num$3_$_hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
  var k$2$1 = (((rhi$3 >>> 0) % 60) | 0);
  var quotLo$2$1 = ((0.016666666666666673 * ((4.294967296E9 * k$2$1) + (rlo$3 >>> 0.0))) | 0.0);
  var remLo$1 = ((rlo$3 - Math.imul(60, quotLo$2$1)) | 0);
  if ((num$3_$_hi < 0)) {
    var lo$3 = ((-remLo$1) | 0);
    var hi$3 = ((-((lo$3 !== 0) | 0)) | 0);
    var x$5_$_lo = lo$3;
    var x$5_$_hi = hi$3;
  } else {
    var x$5_$_lo = remLo$1;
    var x$5_$_hi = 0;
  }
  var buf = $j_java$002elang$002e$002dObject.$ct_scm_StringBuilder__I__(new $j_java$002elang$002e$002dObject.$c_scm_StringBuilder(), 24);
  buf.eQ("PT");
  if (((hours_$_lo | hours_$_hi) !== 0)) {
    buf.Sf(hours_$_lo, hours_$_hi).ia(72);
  }
  if ((x$3_$_lo !== 0)) {
    buf.d9(x$3_$_lo).ia(77);
  }
  if ((((x$5_$_lo === 0) && (this.g8 === 0)) && (buf.ax.l() > 2))) {
    return buf.ax.r;
  }
  if (((x$5_$_lo < 0) && (this.g8 > 0))) {
    if ((x$5_$_lo === (-1))) {
      buf.eQ("-0");
    } else {
      buf.d9(((1 + x$5_$_lo) | 0));
    }
  } else {
    buf.d9(x$5_$_lo);
  }
  if ((this.g8 > 0)) {
    var pos = buf.ax.l();
    if ((x$5_$_lo < 0)) {
      buf.d9(((2000000000 - this.g8) | 0));
    } else {
      buf.d9(((1000000000 + this.g8) | 0));
    }
    while (true) {
      var index = ((buf.ax.l() - 1) | 0);
      if ((buf.ax.qU(index) === 48)) {
        var len = ((buf.ax.l() - 1) | 0);
        buf.ax.Qk(len);
      } else {
        break;
      }
    }
    buf.Xt(pos, 46);
  }
  buf.ia(83);
  return buf.ax.r;
});
$p.ic = (function(that) {
  return this.Of(that);
});
$p.fh = (function(that) {
  return this.Of(that);
});
function $isArrayOf_Ljava_time_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dw)));
}
export { $isArrayOf_Ljava_time_Duration as $isArrayOf_Ljava_time_Duration };
var $d_Ljava_time_Duration = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Duration, "java.time.Duration", ({
  dw: 1,
  dK: 1,
  j: 1,
  aK: 1,
  a: 1
}));
export { $d_Ljava_time_Duration as $d_Ljava_time_Duration };
